angular
  .module('fundingSearchApp.services.Organization', [])
  .service('Organization', function() {
    const showOrganizationLink = organization => !!organization.slug_and_id;
    return { showOrganizationLink };
  });
